import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ReportIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M18 4H6a.945.945 0 00-1 1v15l3-2 2 2 2-2 2 2 2-2 3 2V5a.945.945 0 00-1-1zm-2 10H8v-2h8zm0-4H8V8h8z" />
  </SvgIcon>
);
ReportIcon.displayName = 'ReportIcon';
ReportIcon.muiName = 'SvgIcon';

export default ReportIcon;
